import React from "react";
import "./budget-summary.scss";

export interface BudgetSummaryNumbers {
  budgetInCents?: number;
  refundedCashInCents?: number;
  refundedCreditsInCents?: number;
}

export interface BudgetSummaryProps {
  budgetSummary: BudgetSummaryNumbers;
  onClickChangeBudget: (event: any) => void;
}

export const BudgetSummary: React.FC<BudgetSummaryProps> = props => {
  return (
    <dl className="c-budget-summary">
      <dt>Cash Budget</dt>
      <dd>
        <a href="#" title="Change budget" onClick={props.onClickChangeBudget}>
          {centsToDollars(props.budgetSummary.budgetInCents)}
        </a>
      </dd>
      <dt>Refunded Cash</dt>
      <dd>{centsToDollars(props.budgetSummary.refundedCashInCents)}</dd>
      <dt>Refunded Credits</dt>
      <dd>{centsToDollars(props.budgetSummary.refundedCreditsInCents)}</dd>
    </dl>
  );
};

function centsToDollars(cents?: number) {
  if (typeof cents === "number") {
    const dollarsPart = Math.floor(cents / 100);
    const centsPart = cents % 100;
    const centsFormatted = centsPart < 10 ? `0${centsPart}` : centsPart;
    return `$${dollarsPart}.${centsFormatted}`;
  } else {
    return `-`;
  }
}
